export const InfoOutline = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 8C2.5 4.96443 4.96443 2.5 8 2.5C11.0356 2.5 13.5 4.96443 13.5 8C13.5 11.0356 11.0356 13.5 8 13.5C4.96443 13.5 2.5 11.0356 2.5 8ZM8 1C4.136 1 1 4.136 1 8C1 11.864 4.136 15 8 15C11.864 15 15 11.864 15 8C15 4.136 11.864 1 8 1ZM9 4V6L7 6V4H9ZM9 7V12H7V7H9Z'
      fill='#3B89F6'
    />
  </svg>
);
